var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getWrapper)?_c(_vm.getWrapper,{tag:"component",attrs:{"service":_vm.service}}):(_vm.hasIcon(_vm.service.icon))?_c(_vm.service.icon,{tag:"component",staticClass:"w-100"}):_c('font-awesome-icon',{staticClass:"text-black-50",attrs:{"icon":"question-circle","size":"4x"}})
}
var staticRenderFns = []

export { render, staticRenderFns }